export enum AircraftCode {
  /** B737-800 / B737-MAX 8 style layouts (internal kiosk code) */
  B737_166 = 'P166',
  B737_180 = 'P180',
  B737_9 = 'P7379',
  B787_8 = 'P7878',
  B787_9 = 'P7879',
  EMB190 = 'PE190',
}

export enum SeatCabinClass {
  FIRST_CLASS = 'FIRST_CLASS',
  /** Premier Light / alternate first section code used in some seatmaps */
  FIRST_CLASS180 = 'FIRST_CLASS180',
  AM_PLUS = 'AM_PLUS',
  PREFERRED = 'PREFERRED',
  COACH = 'COACH',
  EXIT_ROW = 'EXIT_ROW',
}

export enum SeatRowCode {
  FIRST = '1',
  SECOND = '2',
  FOURTH = '4',
  FIFTH = '5',
  SIXTH = '6',
  EIGHTH = '8',
  NINTH = '9',
  TENTH = '10',
  FOURTEENTH = '14',
  FIFTEENTH = '15',
  SIXTEENTH = '16',
  SEVENTEENTH = '17',
  TWENTY_FIRST = '21',
  TWENTY_SECOND = '22',
  TWENTY_FIFTH = '25',
  THIRTY_SECOND = '32',
  THIRTY_THIRD = '33',
  THIRTY_FOURTH = '34',
  THIRTY_NINTH = '39',
  FORTIETH = '40',
}

/** Seat column letters used in layout conditionals */
export enum SeatColumnCode {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G',
  H = 'H',
  J = 'J',
}
